import React from 'react'
import { Link } from "react-router-dom"
import useFetch from "../../../hooks/useFetch"
import GriSupplierReportData from "./GriSupplierReportData"

export default function GriSupplierReport() {

    const { data, isLoading } = useFetch('gri/getAllGRI')

    if (isLoading) {
        return (
            <>
                <main className="col-md-9 ms-sm-auto col-lg-10 px-md-4">
                    <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
                        <h1 className="h2"> <i className="fa-solid fa-spinner fa-spin"></i></h1>
                    </div>
                </main>
            </>
        )
    }

    return (
        <>
            <main className="col-md-9 ms-sm-auto col-lg-10 px-md-4">
                <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
                    <h1 className="h2">GRI Supplier Report</h1>
                    <div className='buttons-right supplier-filter'>
                        {/* <DropdownButton id="dropdown-basic-button" variant='Secondary' title="Date">
              <Dropdown.Item href="#/action-1">2020</Dropdown.Item>
              <Dropdown.Item href="#/action-2">2021</Dropdown.Item>
              <Dropdown.Item href="#/action-3">2022</Dropdown.Item>
              <Dropdown.Item href="#/action-4">2023</Dropdown.Item>
            </DropdownButton> */}
                        <Link className='btn btn-light' to="/importreport"><i class="fa-solid fa-file-import"></i> Import Reports</Link>

                    </div>
                </div>
                <table className="table">
                    <thead>
                        <tr>
                            <th>Seller</th>
                            <th>Year</th>
                            <th>Created Date</th>
                        </tr>
                    </thead>
                    <tbody>
                        <GriSupplierReportData data={data} />
                    </tbody>
                </table>
            </main>
        </>
    )
}